module.exports = __webpack_public_path__ + "static/img/logo_JJ.ade20138.png";